module.exports = {
  statistic: {
    hints: {
      monitoring_view: 'Просмотр мониторинга',
      monitoring_download: 'Скачать мониторинг',
    },
    download: 'Скачать',
    show_auto_monitoring: 'Показать автомониторинги',
    download_as_csv: 'Скачать в формате CSV',
    download_as_xls: 'Скачать в формате Excel',
    pageHeader: 'Статистика',
    main_tap_label: 'Общая',
    name: 'Имя',
    score_avg: 'Средний балл',
    monitoring_tap_table: {
      duration: 'Длительность',
      call_id: 'CallID',
      start_date: 'Дата и время начала записи',
      check_date: 'Дата и время проверки',
      controller: 'Контролёр',
      final_score: 'Итоговая Оценка',
      operator: 'Оператор',
      team: 'Команда',
      appeal: 'Апелляция',
      confirmed: 'Подтверждено',
      actions: 'Действия',
    },
    widget: {
      no_block: 'Без блока',
      middle_score: 'Ср.балл',
      count: 'Всего мониторингов',
      completed: 'Проверенных мониторингов',
      duration_avg: 'Средняя длительность разговора',
      score_avg: 'Средний балл',
      accordion_label_button_more: 'Подробнее',
      accordion_label_button_close: 'Свернуть',
      accordion_label_button_monitoring: 'Мониторинги',
      accordion_label_button_teams_details: 'Детализация по командам',
      accordion_label_button_operator_details: 'Детализация по сотрудникам',
    },
    filter: {
      teams_placeholder: 'Команды',
      operators_placeholder: 'Операторы',
      score: 'Итоговая оценка',
      controller: 'Контролер',
      operator: 'Оператор',
      metaFilterButtonLabel: 'Добавить условия по метаданным',
    },
    dt_type: {
      processing: 'По дате проверки',
      start: 'По дате коммуникации',
    },
    range: {
      cd: 'Текущий день',
      cw: 'Текущая неделя',
      cm: 'Текущий месяц',
      pd: 'Предыдущий день',
      pw: 'Предыдущая неделя',
      pm: 'Предыдущий месяц',
      r: 'Диапазон',
      n: 'Все данные',
    },
  },
  monitoring_tasks: {
    period_desc: 'Период выполнения задания:',
    period_desc_from: 'с',
    period_desc_to: 'по',
    delete_monitoring_text: 'Вы действительно хотите удалить это задание на мониторинг?',
    new_status: 'Новое',
    show_completed: 'Показывать проверенные',
    tabs: {
      main: 'Основные настройки',
      controllers: 'Проверяющие',
      monitoring: 'Мониторинги',
    },
    page_title: 'Задания на мониторинг',
    add_task_button: 'Добавить задание',
    status: {
      status_will_be_changed: 'Статус будет изменен с ',
      change_status_failed: 'Ошибка смены статуса , возможно вы не заполнили задание',
      to: ' на ',
    },
    table: {
      hints: {
        copy: 'Скопировать',
        delete: 'Удалить',
        complete: 'Завершить',
        settings: 'Настроить',
        monitoring_view: 'Просмотр мониторинга',
      },
      name: 'Название',
      dt_start: 'Начало',
      dt_end: 'Окончание',
      status: 'Статус',
      progress: 'Прогресс',
      actions: 'Действия',
      dt_add_col: 'Дата добавления в задание',
      dt_start_col: 'Дата коммуникации',
      operator_id_col: 'Оператор',
      team_id_col: 'Команда',
      complete_col: 'Завершено',
      dt_completion_col: 'Дата проверки',
      confirmed_col: 'Подтверждено',
      actions_col: 'Действия',
    },
    controllers_modal: {
      hints: {
        edit: 'Редактировать',
        delete: 'Удалить',
      },
      title: 'Проверяющие',
      load_distribution_label: 'Равномерное распределение нагрузки между проверяющими',
      auto: 'Авто',
      total_distributed: 'Итого распределено',
      manual: 'Ручная',
      table: {
        username: 'Имя проверяющего',
        id_percent: 'Проценты',
        actions: 'Действия',
      },
      add_controller_button: 'Добавить контролёра',
      approve_button: 'Сохранить',
      cancel_button: 'Отменить',
    },
    form: {
      new_task_title: 'Создать задание',
      pause_project: 'Остановить задание',
      start_project: 'Запустить задание',
      label: 'Задание на мониторинг',
      name: 'Название',
      description: 'Описание',
      mForm: 'Мониторинговая форма',
      interval_start: 'Дата начала задания',
      interval_end: 'Дата окончания задания',
      rec_select: 'Выбор записей на мониторинг',
      operator_bind: 'Распределение между операторами',
      operator_bind_desc:
        'Равномерный отбор записей на мониторинг по всем выбранным в условиях операторам',
      qm_operators: 'qm_operators',
      qm_teams: 'qm_teams',
      load_distribution: 'Распределение нагрузки',
      NDAY: 'количество записей за день',
      PDAY: 'процент от всех записей за день',
      PHOUR: 'процент от всех записей за час',
      dncm: 'Не создавать мониторинги для записей, которые не распределяются на контролеров',
      dnis: 'Не учитывать в статистике непроверенные мониторинги, которые распределены между контролерами',
      op_approve: 'Подтверждение оператором',
      approve_button: 'Сохранить',
      cancel_button: 'Отменить',
    },
  },
  monitoring_forms: {
    status_new: 'Новая',
    status_active: 'Активная',
    hints: {
      settings: 'Настроить',
      copy: 'Скопировать',
      download: 'Скачать',
      deleteHint: 'Удалить',
    },
    page_title: 'Мониторинговые формы',
    actions: 'Действия',
    download_as_xlsx: 'Выгрузить в xlsx',
    download_as_pdf: 'Выгрузить в pdf',
    move_group: 'Переместить в группу',
    remove_choosen: 'Удалить выбранные',
    start_project: 'Сделать форму активной',
    chats: 'Чаты',
    records: 'Записи',
    deleteMFDescription: 'Вы действительно хотите удалить данную мониторинговую форму?',
    moveMFToArchive: 'Мониторинговую форму нельзя удалить в статусе Активная. Перенести в архив?',
    table: {
      name: 'Название',
      dt_add: 'Дата создания',
      status: 'Статус',
      actions: 'Действия',
    },
    pageTitle: 'Мониторинговые формы',
    addFormButtonLabel: 'Создать мониторинговую форму',
    createMonitoringForm: {
      fill_from_template: 'Заполнить из шаблона',
      successfully_changed: 'Изменения успешно сохранены',
      delete_criteria_description: 'Вы действительно хотите удалить критерий?',
      criteria_table: {
        hints: {
          delete: 'Удалить',
          edit: 'Редактировать',
          setting: 'Настроить',
        },
        delete_block_description: 'Вы действительно хотите удалить данный блок?',
        name: 'Название',
        dt_add: 'Дата создания',
        type: 'Способ оценки',
        comments_type: 'Тип комментария',
        rating_scale_name: 'Название шкалы оценок',
        additionally: 'Дополнительно',
        actions: 'Действия',
        new_block: 'Новый блок',
        crit_mf: 'Крит. МФ',
        crit_block: 'Крит. блок',
        select: 'Выбор из списка',
        input: 'Свободный ввод',
        manual: 'Ручная',
        auto: 'Авто',
        na_option: 'N/A',
        create_block_modal: {
          label: 'Настройки блока',
          conditional_formatting: 'Условное форматирование',
          name: 'Название',
          description: 'Описание',
          approve_button: 'Сохранить',
          cancel_button: 'Отменить',
        },
      },
      days: '%{num} дней',
      day: '%{num} дня',
      indefinitely: 'бессрочно',
      create_new_monitoring_form: 'Создать мониторинговую форму',
      modal_title: 'Мониторинговые формы',
      tabs: {
        main: 'Общие настройки',
        eval_criteria: 'Критерии оценки',
        preview: 'Предпросмоотр',
      },
      title: 'Название',
      description: 'Описание',
      ap_project: 'Аналитический проект',
      eval_method: 'Метод оценки',
      assessment_calc: 'Метод расчёта оценки',
      final_score: 'Итоговый балл',
      conditional_formatting: 'Условное форматирование',
      appeal_deadline: 'Срок для апелляций',
      calc_deep: 'Глубина изменений при пересчёте метрик',
      min: 'мин',
      max: 'макс',
      approve_button: 'Сохранить',
      cancel_button: 'Отменить',
      //criteria
      criteria_eval_method: 'Способ оценки',
      block: 'Блок',
      criteria_metric: 'Метрика',
      criteria_rating_scale: 'Шкала оценки',
      criteria_rating_type: 'Метод оценки',
      criteria_add_button: 'Добавить критерий',
      criteria_eq: 'Равно',
      criteria_range: 'Диапазон',
      na_value: 'Значение N/A',
      default_value: 'Оценка по умолчанию',
      critical_block: 'Критично для блока',
      critical_monit_form: 'Критично для МФ',
      scale_name: 'Название шкалы оценки',
      rating_scale: 'Шкала оценок',
      rating_scale_type: 'Условие',
      rating_scale_condition: 'Значение',
      rating_scale_rating: 'Балл',
      rating_scale_score_: 'Балл',
      rating_scale_weight: 'Вес (%)',
      rating_scale_description: 'Описание',
      rating_scale_color: 'Цвет',
      rating_scale_value: 'Значение',
      rating_scale_icon: 'Иконка',
      rating_scale_default_value: 'По умолчанию',
      pictogram: 'Иконка',
      value: 'Значение',
      both: 'Оба',
      display_type: 'Способ отображения комментария',
      comments_type: 'Способ ввода комментария',
      select_comment: 'Выбор из списка',
      input_comment: 'Свободный ввод',
      comments_select_items_title: 'Варианты Выбора',
    },
  },
  commands: {
    change_status_err: 'Смена статуса недоступна. Пожалуйста, выберете супервайзера.',
    statuses: {
      NEW: 'Новая',
      ACTIVE: 'Активная',
      DISBANDED: 'Расформирована',
    },
    pageTitle: 'Команды',
    addFormButtonLabel: 'Создать команду',
    disband: 'Расформировать',
    settings_hint_title: 'Настроить',
    operators_hint_title: 'Выбор операторов',
    start: 'Запустить',
    table: {
      name: 'Название',
      dt_add: 'Дата создания',
      status: 'Статус',
      supervisor: 'Супервайзер',
      count_operators: 'Кол-во операторов',
      operators: 'Операторы',
      actions: 'Действия',
    },
    operators_modal: {
      maybeOperatorInOtherTeam:
        'Выбор оператора недоступен. Данный оператор уже числится в другой команде.',
      label: 'Операторы',
      username: 'Имя пользователя',
      status: 'Статус',
    },
    create_command_form: {
      label: 'Настройки',
      name: 'Название',
      description: 'Описание',
      operator: 'Оператор',
      supervisor: 'Супервайзер',
      approve_button: 'Сохранить',
      cancel_button: 'Отменить',
    },
  },
};
